$(document).ready(function(){
  /*** Top Bar with Justuno <--
   * * Check if URL have the parameter utm_source
   * * In Justuno we'll check the value of utmParamStorage in local storage
  ***/
  // var queryString = window.location.search,
  //     urlParams = new URLSearchParams(queryString),
  //     find_value = urlParams.get('utm_source');
  
  // if(find_value != null)
  //   sessionStorage.setItem('utmParamStorage', find_value);
  /*--> End Top Bar with Justuno <--*/

  /*** Select all links with hashes ***/
  $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').not('.carousel-control-next,carousel-control-prev').click(function(event) {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        event.preventDefault();
        $('html, body').animate({
          scrollTop: Math.max(target.offset().top - 30, 0) 
        }, 1000, function() {
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) {
            return false;
          } else {
            $target.attr('tabindex','-1');
            $target.focus();
          };
        });
      }
    }
  });
  
  /*** Function Accordion ***/
  $(".accordion").click(function(){
    var btn = $(this);
    var position;

    if(btn.next(".panel").is(":visible")){
      $(".panel:visible").slideUp("normal",function(){
        $(".accordion").removeClass("active");
      });
      exit;
    }
    
    if($(".panel").is(":visible")){
      
      $(".accordion").removeClass("active");
      
      $(".panel:visible").slideUp("normal",function(){
        btn.next(".panel").slideDown("normal", function(){
          position = btn.offset().top;
          $("body, html").animate({
            scrollTop: position
          },500);
        });
        if(btn.next(".panel").is(":visible")){
          btn.addClass("active");
        }else{
          btn.removeClass("active");
        }
        
      });
      
    }else{
      btn.next(".panel").slideDown("normal");
      btn.addClass("active");
    }
  });

  /*** Open/Close FAQs ***/
  if ($('.faq-module').length > 0 ) {
    var question = $('h3.faq-question');
    var answer = $('.faq-answer');
    question.click(function() {
      if ($(this).next(answer).is(':hidden')) {
        if (answer.is(':visible')) {
          answer.slideUp('fast', function() {
            $(this).prev(answer).children('span').removeClass('fa-minus').addClass('fa-plus');
            question.removeClass('open');
            answer.removeClass('open');
          });
        }
        $(this).next(answer).slideDown('normal', function() {
          $(this).addClass('open');
          $(this).prev(question).addClass('open');
          $(this).prev(question).children('span').removeClass('fa-plus').addClass('fa-minus');
        }); 
        } else {
          $(this).next(answer).removeClass('open').slideUp('fast', function() {
          $(this).prev(question).children('span').removeClass('fa-minus').addClass('fa-plus');
          $(this).prev(question).removeClass('open');
        });
      }
    });
  }
  
  
  /*** Functions Categories ***/
  if($('#uncomplicated-categories').hasClass('no-active-cat')){
  	$('#uncomplicated-categories li:first-child').addClass('activecat');
  }
  
  /*** Categories Mobile ***/
  if($(window).width() < 992) {
    /*$('#categories_button').click(function(){
      $('.modal-categories').fadeIn('normal', function(){
        $('body,html').css('overflow','hidden');
      });
    });*/
    
    $('h1 span').click(function(){
      $('.modal-categories').fadeIn('normal', function(){
        $('body,html').css('overflow','hidden');
      });
    });
    
    $('.categories-close svg').click(function(){
      $('.modal-categories').fadeOut('normal', function(){
        $('body,html').css('overflow','auto');
      });
    });
  }

  /*** Validate Login ***/
  if($('#customer_login').length > 0) {
    $('#customer_login').submit(function(){
      var errors;
      $('#customer_login .errors').css('display','none');
      if($('#customer_email').val().length > 0){
        errors = false;
        //console.log('paso email');
      } else {
        errors = true;
        $('#login_email .errorCustom').css('display','block');
      }

      if($('#customer_password').val().length > 0) {
        errors = false;
        console.log('paso password');
      } else {
        errors = true;
        $('#login_password .errorCustom').css('display','block');
      }

      /*if($('#agree').is(':checked')) {
        errors = false;
        console.log('paso terminos');
      } else {
        errors = true;
        $('.agreeWrap .errorCustom').css('display','block');
      }*/

      if(errors == true)
        return false;
    });
  }

  // Add to cart How to use it
  $('.add_cart_ajax').on('click', function(){
    var idform = $(this).data('form');
    $('form#'+idform).submit();
  });

  // Open Modal Video in Page Product
  $('.open-modal').on('click', function(){
    var video = 'https://www.youtube.com/embed/'+$(this).data('video')+'?rel=0&amp;autoplay=1';
    $('#modalVideo iframe').attr('src',video);
  });
  
  $('#modalVideo').on('hide.bs.modal', function(e){
    $('#modalVideo iframe').attr('src','');
  });

  $('.view-more').click(function(){
    $(this).next('.more').slideToggle('slow', function(){
      if($(this).is(':visible')){
        $(this).prev('.view-more').children('i').removeClass('fa-chevron-down').addClass('fa-chevron-up');
        $(this).prev('.view-more').children('span').html('less');
      }else{
        $(this).prev('.view-more').children('i').removeClass('fa-chevron-up').addClass('fa-chevron-down');
        $(this).prev('.view-more').children('span').html('more');
      }
      $('html,body').animate({ scrollTop: $(this).prev('.view-more').offset().top}, 'slow');
    });
  });
  
  $('.add-simple').click(function(){
    var products = $(this).data('products');
    addSimple(products);
  });

  /*** Product Page BNY ***/
  // if($('#shopify-section-product-bny-template').length > 0) {
  //   /* Menu fixed on desktop */
  //   productMenuFixed();
  //   $(window).on('scroll', function(){
  //     productMenuFixed();
  //   });
  // }

  // Menu mobile Customer
  $('.user_button').on('click', function() {
    $('.wrap-menu-account-mobile').fadeIn('fast', function(){
      $('.menu-account-mobile').slideDown('normal');
    });
  });
  
  $('.wrap-menu-account-mobile').on('click', function(e) {
    $('.menu-account-mobile').slideUp('fast', function(e){
      $('.wrap-menu-account-mobile').fadeOut();
    });
  });

  // Loyalty Yotpo in Account
  if(window.location.href.indexOf("account") > -1 && window.location.hash != '') {
    var hash = window.location.hash;
    hash = hash.replace('#','');
    hash = 'account'+hash.substring(0,1).toUpperCase() + hash.substring(1);
    if(hash != '') {
      menuAccount(hash);
    }
  }

  /* Show/Hide sticky menu on scroll */
  //-> On load document
  if($('#bnyHeader').data('position') == 'sticky') {
    stickyMenu();
  }

  // Active sticky Add to Cart
  if($('.action_button.add_to_cart').data('position') == 'sticky') {
    //stickyBtnAddtoCart();
  }

  //-> On scroll window
  if($('#bnyHeader').data('position') == 'sticky') {
    $(window).on('scroll', function() {
      stickyMenu();
    });
  }

  // Active sticky Add to Cart
  if($('.action_button.add_to_cart').data('position') == 'sticky') {
    $(window).on('scroll', function() {
      //stickyBtnAddtoCart();
    });
  }

  /* Open/Close SideMenu (only mobile) */
  $('#sideNav').on('click', function(e) {
    if(e.target == this) {
      openCloseMenu();
    }
  });

  /* Start Quiz */
  $('.quiz-start').click(function(){
    $('.quiz-intro').slideUp();
    $('.quiz-wrap-embedded').slideDown();
    // $('.quiz-intro').css('display','none');
  });

  /* Quiz Kit */
  //$('[data-section-id="products_1"]').after('<div class="mb-5"><button id="quiz-add-all" class="d-block mx-auto btn-add-all" onclick="document.getElementById(\'layout-1-results-bundle-button\').click();">Add All Products</button></div>');
});

/*document.addEventListener('quizKitResultsPageLoaded', function (e) {
  //let products = document.querySelector('section[data-section-id="products_1"]');
  let products = window.querySelectorAll('#quiz-kit-results-grid-qW7fRel6UV7');
  console.log(products);
  products[0].insertAdjacentHTML('afterend','<div class="mb-5"><button id="quiz-add-all" class="d-block mx-auto btn-add-all" onclick="document.getElementById(\'layout-1-results-bundle-button\').click();">Add All Products</button></div>');
}, false);*/

const stickyMenu = () => {
  var hmenu = $('#bnyHeader').height(),
      margintop = $('body').css('margin-top'),
      x = $(this).scrollTop();
  if(x > hmenu) {
    //$('#bnyHeader').addClass('sticky-top').css('top',margintop);
    $('#bnyHeader').addClass('sticky-top');
    $('body').css('padding-top',hmenu);
  } else {
    $('#bnyHeader').removeClass('sticky-top');
    $('body').css('padding-top','0');
  }
}

const stickyBtnAddtoCart = () => {
  let spaceTop = 120;
      scrollY = $(this).scrollTop() + spaceTop;
      containerTop = $('.purchase-details__buttons').offset().top;
  if(scrollY > containerTop) {
    $('.action_button.add_to_cart, .rc-container-wrapper').addClass('sticky');
  } else {
    $('.action_button.add_to_cart, .rc-container-wrapper').removeClass('sticky');
  }
}

/*** Product Page BNY ***/
/* Menu fixed on desktop */
function productMenuFixed() {
  var productmenu = $('.product-bny--menu');
  var menuOffsetY = productmenu.offset().top;
  if(productmenu.length > 0 && productmenu.is(':visible')) {
    if($(window).scrollTop() >= menuOffsetY && !productmenu.children('.nav').hasClass('fixed-to')) {
      productmenu.find('.nav').addClass('fixed-top');
    } else if($(window).scrollTop() <= productmenu.offset().top) {
      productmenu.find('.nav').removeClass('fixed-top');
    }
  }
}

/* New Fast Shop */
function fastShop(url, type, discount){
  $('.fast-overlay .fast-image').attr('src','');
  $('.fast-overlay .fast-title').html('');
  $('.fast-overlay .fast-price').html('');
  
  $.getJSON(url+'.js', function(product){
    var product_id = product.variants[0].id;
    var data = {
      items: [
        {
          quantity: 1,
          id: product_id
        }
      ]
    };
    var product_image = product.images[1];
    var product_name = product.title;
    var product_price = product.price;
    var product_was_price = (discount != null) ? (product_price - (discount*product_price)/100) : product.variants[0].compare_at_price;

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: data,
      async: true,
      beforeSend: function(){
        if(type != null){
          $('#'+product.id+" .btn-cross").html('Wait').after('<div class="blocker"></div>');
        }else{
          $('.fast-overlay .modal-content').css('background-image','url("//cdn.shopify.com/s/files/1/0069/0546/2882/t/6/assets/loader.gif")');
          /*$.fancybox.open({
            'content': $('.fast-overlay'),
            'gutter': 30
          });*/
          $('.fast-overlay').modal('show');
        }
      },
      success: function(data){
        pintrk('track', 'addtocart');
        if(type != null){
          $('#'+product.id+" .btn-cross").html('Added').addClass('added').addClass('disabled');
          $('#'+product.id+" .blocker").hide();
        }else{
          $('.fast-overlay .modal-content').css('background-image','none');
          $('.fast-overlay .fast-image').attr('src',product_image);
          $('.fast-overlay .fast-title').html(product_name);
          if(product_was_price > 0 && product_was_price < product_price) {
            //$('.fast-overlay .fast-price').html('$'+product_was_price.toString().substring(-2,2)+'.00');
            $('.fast-overlay .fast-price').html('$'+product_was_price.toString().substring(-2,2)+'.'+product_was_price.toString().slice(-2));
            $('.fast-overlay .fast-was-price').html('$'+product_price.toString().substring(-2,2)+'.'+product_price.toString().slice(-2));
          } else {
            $('.fast-overlay .fast-price').html('$'+product_price.toString().substring(-2,2)+'.'+product_price.toString().slice(-2));
            //$('.fast-overlay .fast-was-price').html('$'+product_was_price.toString().substring(-2,2)+'.'+product_was_price.toString().slice(-2));
          }
          // AfterPay
          if(discount != null) {
            $('.fast-overlay afterpay-placement').attr('data-amount',product_was_price.toString().substring (-2,2)+'.'+product_was_price.toString().slice(-2));
          } else {
            $('.fast-overlay afterpay-placement').attr('data-amount',product_price.toString().substring (-2,2)+'.'+product_price.toString().slice(-2));
          }
        }
          
        let count = parseInt($('span.cart_count').html());
        $('span.cart_count').html(count+1);
        
        // Mobile icon cart
        $('.cart-btn-movil span.fa-shopping-bag').html('<i class="mark-cart"></i>');
      }
    });
  });
}

/* Open/Close SideMenu (only mobile) */
const openMenu = () => {
  $('#sideNav').fadeIn('normal', function(){
    $('.wrapper-side-nav').animate({left:0});
    $(this).addClass('open-side-nav');
  });
}

const closeMenu = () => {
  $('.wrapper-side-nav').animate({left:'-100%'}, function() {
    $('#sideNav').fadeOut('normal', function(){
      $(this).removeClass('open-side-nav');
    });
  });
}

const openCloseMenu = () => {
  if($('#sideNav').hasClass('open-side-nav')) {
    closeMenu();
  } else {
    openMenu();
  }
}

/* Get Parameters from URL */
function GetURLParameter(sParam){
  var sPageURL = window.location.search.substring(1);
  var sURLVariables = sPageURL.split('&');
  for (var i = 0; i < sURLVariables.length; i++){
    var sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] == sParam){
      return sParameterName[1];
    }
  }
}

/* ReCharge */
$(document).ready(function(){
  if($('#ReCharge').length > 0) {
    $('#ReCharge .col-md-6').addClass('m-auto');
  }
});

/* Add to cart simple */
function addSimple(products) {
  var products = products.toString().split(',');
  var data = new Object;
  var items = new Array();
  for(var i=0; i<products.length; i++){
    items.push({
      quantity: 1,
      //id: 31239332069474
      id: parseInt(products[i])
    });
  }
  data.items = items;
  //console.log(data);
  //console.log(JSON.stringify(data)); // aqui tienes la lista de objetos en Json
  
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    //dataType: 'application/json',
    data: data,
    async: true,
    beforeSend: function(){
    },
    success: function(data){
      pintrk('track', 'addtocart');
      window.location.href = '/cart';
      //console.log('paso');
    }
  });
}

function menuAccount(m) {
  var module = '#'+m;
  var item = '.item-menu-account.'+m;
  if(!$(item).hasClass('current')) {
    $('.module-account:visible').slideUp('normal', function(){
      $('.item-menu-account.current').removeClass('current');
      $(module).slideDown('normal', function(){
        $(item).addClass('current');
      });
    });
    // Mobile
    $('.menu-account-mobile').slideUp('normal');
  }
}

function getMutationObserver(className, func) {
  return new MutationObserver(function(mutations, o) {
    mutations.forEach((element) => {
      element.addedNodes.forEach(node => {
        if (node.className === className) {
          func();
          console.log(`${className} is now appended.`);
          o.disconnect();
        }
      });
    });
  });
}

const search = window.location.search;
if (search.indexOf('chat=on') > -1) {
  const observer = getMutationObserver('hiro-chat-widget-toggle', openChatWidget);
  observer.observe(document.body, { childList: true });
}
/* Hiro Chat - Magnet Beauty */
